export const displayFileSize = (size: number): string => {
  if (size < 1000 && size > 0) return "1KB";
  if (size < 1_000_000) return (size / 1000).toFixed(2) + "KB";
  if (size >= 1_000_000) return (size / 1_000_000).toFixed(2) + "MB";
  return "0KB";
};

